module.exports = __webpack_public_path__ + "cfab35032755c3b332f7d7cef4817fc6.jpg";